import { MenuItem, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import {
  useMutation,
  useListContext,
  sanitizeFetchType,
  useNotify,
  useTranslate,
} from 'react-admin'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { AccessVariantsRecurringDialog } from '../AccessDialogs'
import { BulkActionProps } from '../../../common/BulkActionsProps'
import { AccessDto } from '../../../../core/dto/access.dto'
import { DateTime } from '../../../../core/common/date-time'

export const AccessAttachVariantRecurringBulkButton = ({
  selectedIds,
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  innerRef,
  ...props
}: BulkActionProps) => {
  const { loading, refetch } = useListContext<AccessDto>()
  const notify = useNotify()
  const translate = useTranslate()
  const hasAuthority = useHasAuthority()
  const [selectStateDialogOpen, setSelectStateDialogOpen] = useState(false)
  const [mutate, { loading: mutationLoading }] = useMutation()
  const [variantId, setVariantId] = useState<number | undefined>()

  const handleMutation = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    const query = {
      type: sanitizeFetchType('attachAccesses'),
      resource: ResourceName.VARIANTS,
      payload: {
        variantId,
        accessesIds: selectedIds,
        recurringJobName,
        cronExpression,
        scheduledAt,
      },
    }
    const result = await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    return result
  }

  const handleAttachVariants = async (
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => {
    setSelectStateDialogOpen(false)
    handleMutation(recurringJobName, cronExpression, scheduledAt)
    refetch()
  }

  const handleDialogClose = () => {
    setSelectStateDialogOpen(false)
  }

  return (
    <MenuItem
      {...props}
      disabled={
        !selectedIds.length ||
        !hasAuthority(Authority.EDIT_ACCESSES) ||
        !hasAuthority(Authority.VIEW_VARIANTS) ||
        loading ||
        mutationLoading
      }
      onClick={() => setSelectStateDialogOpen(true)}
      button
    >
      <Typography>
        {translate('resources.accesses.actions.attachVariants-recurring')}
      </Typography>
      <AccessVariantsRecurringDialog
        open={selectStateDialogOpen}
        close={handleDialogClose}
        setSelectedVariantId={setVariantId}
        handleAttachment={handleAttachVariants}
        method="attach"
      />
    </MenuItem>
  )
}
